export default __webpack_public_path__ + "static/media/fees.dbd3896d.svg";